import moment from 'moment'

export default {
  methods: {
    dateFormat: function (date) {
      return moment.utc(date).local().format('MMMM Do YYYY, h:mm:ss a')
    }
  }
}
